import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseToast } from './PurchaseToast';
export function Hero() {
  return <section className="relative min-h-fit bg-transparent text-slate-900 flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-12 pb-2 md:pb-4 overflow-hidden font-sans" data-id="element-92">
      {/* Brand Header */}
      <div className="flex items-center gap-2 mb-1 md:mb-6" data-id="element-93">
        <span className="text-blue-600 font-black tracking-widest text-sm md:text-sm uppercase" data-id="element-94">
          GUIADIGITAL360 TM
        </span>
      </div>

      {/* Main Title */}
      <h1 className="text-4xl md:text-7xl lg:text-8xl font-black text-center max-w-5xl leading-[1] mb-2 md:mb-8" data-id="element-95">
        Química en Acción <br data-id="element-96" />
        <span className="text-blue-600" data-id="element-97">Todo tu año resuelto.</span>
      </h1>

      {/* Product Visual Mockup */}
      <div className="relative w-full max-w-[260px] md:max-w-[500px] mb-0 md:mb-6" data-id="element-98">
        <img src="https://cdn.magicpatterns.com/uploads/o4RouXz77WZXyquLNbF62G/quimica_box_mobile_optimizada.png" alt="MegaPack Química en Acción Mockup" width={1080} height={1080} className="w-full h-auto drop-shadow-2xl" data-id="element-99" />
      </div>

      {/* Quote and Sub-headline */}
      <div className="text-center space-y-1 mb-2 md:mb-6 max-w-2xl animate-fade-in" data-id="element-100">
        <p className="text-blue-700 italic text-lg md:text-2xl font-medium px-2 leading-tight mt-[-10px] mb-[-10px]" data-id="element-101">
          "Planificación total. De 1° a 5° año. Con actividades, rúbricas y
          experiencias ."
        </p>
        <p className="text-slate-600 text-xs md:text-xl font-bold" data-id="element-102">
          5 Cuadernillos + 6 Bonos Estratégicos
        </p>
      </div>

      {/* CTA Button */}
      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 25px rgba(34,197,94,0.4)', '0 0 15px rgba(34,197,94,0.2)'],
      scale: [1, 1.01, 1]
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut'
    }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="w-full max-w-xs md:max-w-none bg-green-600 hover:bg-green-700 active:scale-95 text-white font-black text-lg md:text-2xl py-4 md:py-5 px-6 md:px-10 rounded-2xl shadow-[0_10px_30px_rgba(34,197,94,0.3)] flex items-center justify-center gap-3 transition-all mb-3 md:mb-6" data-id="element-103">
        <span data-id="element-104">⚗️</span>
        <span data-id="element-105">QUIERO MI MEGAPACK</span>
      </motion.button>

      {/* Trust Badges */}
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 md:gap-12 text-[9px] md:text-base font-bold text-slate-500 animate-fade-in" data-id="element-106">
        <div className="flex items-center gap-2" data-id="element-107">
          <span className="text-xl" data-id="element-108">📄</span> 100% PDF
        </div>
        <div className="flex items-center gap-2" data-id="element-109">
          <span className="text-xl" data-id="element-110">⚡</span> Acceso inmediato
        </div>
        <div className="flex items-center gap-2" data-id="element-111">
          <span className="text-xl" data-id="element-112">🇦🇷</span> Currículo argentino
        </div>
      </div>

      <PurchaseToast data-id="element-113" />
    </section>;
}